import { render } from "./aio-login-two-factor-authentication.vue?vue&type=template&id=5c80700e&scoped=true"
import script from "./aio-login-two-factor-authentication.vue?vue&type=script&lang=js"
export * from "./aio-login-two-factor-authentication.vue?vue&type=script&lang=js"

import "./aio-login-two-factor-authentication.vue?vue&type=style&index=0&id=5c80700e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c80700e"]])

export default __exports__